import { Checkbox, TextField } from "@material-ui/core";
import {
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import Divider from "@material-ui/core/es/Divider/Divider";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUpload from "@material-ui/icons/CloudUpload";
import axios from "axios";
import {
  InlineDatePicker,
  InlineDateTimePicker,
  InlineTimePicker,
} from "material-ui-pickers";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";

class FormCampaign extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChangeReference = (e, id, id_item) => {
    e.preventDefault();
    const value = e.target.value;
    const { onUpdateSate } = this.props;
    onUpdateSate(value, id, id_item);
  };

  handleChangeDate = (date, id, id_item) => {
    const { onUpdateSate } = this.props;
    onUpdateSate(date, id, id_item);
  };

  handleChangeContentViaRefference = (e, id, id_item) => {
    e.preventDefault();
    const value = e.target.value;
    const { onUpdateSate } = this.props;
    onUpdateSate(value, id, id_item);
  };

  handleChangeText = (e, id, id_item) => {
    e.preventDefault();
    const value = e.target.value;
    const { onUpdateSate } = this.props;
    onUpdateSate(value, id, id_item);
  };

  handleChangeCheckBox = (e, id, id_item) => {
    let value;

    if (e.target.name === "multi-check-box") {
      value = e.target.value;
    } else {
      value = JSON.parse(e.target.value);
    }

    const { onUpdateSate } = this.props;
    onUpdateSate(value, id, id_item);
  };

  handleChangeComment = (e, id) => {
    const { onUpdateComment } = this.props;
    const value = e.target.value;
    onUpdateComment(value, id);
  };

  upload = (e, type, id, id_tem) => {
    const { token, onUpdateSate } = this.props;
    const data = new FormData();
    data.append("file", e.target.files[0]);
    data.append("type", type);
    data.append("id", id);
    data.append("id_item", id_tem);

    axios
      .post(
        `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/upload`,
        data,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        onUpdateSate(res.data.result.files.file[0].name, id, id_tem);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  download = (file) => {
    window.location.href = `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/download/${file}`;
  };

  renderTypeForm = () => {
    const {
      type,
      classes,
      options,
      id,
      reasonSelectList,
      question,
      index,
      note,
      disabled,
      layout,
    } = this.props;

    switch (type) {
      case "datetime": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container className={classes.grid}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <InlineDateTimePicker
                    margin="normal"
                    label="Ngày giờ"
                    variant="outlined"
                    className={classes.input}
                    disabled={disabled}
                    format="dd-MM-yyyy HH:mm"
                    name="datetime"
                    value={item.text ? item.text : null}
                    onChange={(date) =>
                      this.handleChangeDate(date, id, item.id)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon>event_note</Icon>
                        </InputAdornment>
                      ),
                      className: classes.input,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    disabled={disabled}
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "time": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container className={classes.grid}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <InlineTimePicker
                    margin="normal"
                    label="Thời gian"
                    variant="outlined"
                    className={classes.input}
                    disabled={disabled}
                    format="HH:mm"
                    name="time"
                    value={item.text ? item.text : null}
                    onChange={(date) =>
                      this.handleChangeDate(date, id, item.id)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon>event_note</Icon>
                        </InputAdornment>
                      ),
                      className: classes.input,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    disabled={disabled}
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "date": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container className={classes.grid}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <InlineDatePicker
                    margin="normal"
                    label="Ngày tháng năm"
                    variant="outlined"
                    className={classes.input}
                    format="dd-MM-yyyy"
                    disabled={disabled}
                    name="date"
                    value={item.text ? item.text : null}
                    onChange={(date) =>
                      this.handleChangeDate(date, id, item.id)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon>event_note</Icon>
                        </InputAdornment>
                      ),
                      className: classes.input,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    disabled={disabled}
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "text": {
        return options.map((item) => {
          return (
            <Grid container className={classes.grid}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Câu trả lời ngắn"
                  disabled={disabled}
                  className={classes.input}
                  value={item.text ? item.text : ""}
                  name="text"
                  InputProps={{
                    className: classes.input,
                  }}
                  onChange={(event) =>
                    this.handleChangeText(event, id, item.id)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label={`Ghi chú câu hỏi ${index + 1}`}
                  variant="outlined"
                  disabled={disabled}
                  className={classes.input}
                  onChange={(event) => this.handleChangeComment(event, id)}
                  value={note}
                  name="note"
                  multiline
                  rows={3}
                  InputProps={{
                    className: classes.input,
                  }}
                />
              </Grid>
            </Grid>
          );
        });
      }
      case "paragraph-text": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container className={classes.grid}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField
                    id="outlined-full-width"
                    margin="normal"
                    label="Câu trả lời"
                    disabled={disabled}
                    className={classes.input}
                    value={item.text ? item.text : ""}
                    name="paragraph-text"
                    InputProps={{
                      className: classes.input,
                    }}
                    multiline
                    rows={3}
                    onChange={(event) =>
                      this.handleChangeText(event, id, item.id)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    disabled={disabled}
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "check-box": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container className={classes.grid}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <RadioGroup
                    aria-label="Gender"
                    className={classes.input}
                    value={item.text}
                    name="check-box"
                    onChange={(event) =>
                      this.handleChangeCheckBox(event, id, item.id)
                    }>
                    <FormControlLabel
                      value={true}
                      disabled={disabled}
                      control={
                        <Radio
                          classes={{
                            disabled: classes.disabled ? classes.disabled : "",
                          }}
                        />
                      }
                      label="Đồng ý"
                      classes={{
                        disabled: classes.label ? classes.label : "",
                      }}
                    />
                    <FormControlLabel
                      value={false}
                      disabled={disabled}
                      control={
                        <Radio
                          classes={{
                            disabled: classes.disabled ? classes.disabled : "",
                          }}
                        />
                      }
                      label="Không đồng ý"
                      classes={{
                        disabled: classes.label ? classes.label : "",
                      }}
                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    disabled={disabled}
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "select-list": {
        let isValid = false;
        let refer = [];
        let content = [];

        reasonSelectList.forEach((item) => {
          if (item.id === options.id) {
            if (item.values[0].type) {
              isValid = true;

              item.values.forEach((it) => {
                if (it.type === options.refer) {
                  content.push(it.text);
                }

                let isFound = refer.some((text) => it.type === text);
                if (!isFound) {
                  refer.push(it.type);
                }
              });
            } else {
              isValid = false;
              item.values.forEach((it) => {
                content.push(it.text);
              });
            }
          }
        });

        return (
          <Grid container spacing={24}>
            {
              //Với những tham chiếu mà type === "" thì chỉ chọn nội dung
              isValid ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Tham chiếu"
                    disabled={disabled}
                    variant="outlined"
                    className={classes.input}
                    onChange={(e) => this.handleChangeReference(e, id, "refer")}
                    value={options.refer ? options.refer : ""}
                    name="select-list"
                    validators={["required"]}
                    errorMessages={"Không được để trống"}
                    InputProps={{
                      className: classes.input,
                    }}>
                    {refer.map((item, index) => {
                      return (
                        <MenuItem key={item + index} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                </Grid>
              ) : null
            }
            <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Nội dung"
                disabled={disabled}
                variant="outlined"
                className={classes.input}
                onChange={(e) =>
                  this.handleChangeContentViaRefference(e, id, "content")
                }
                value={options.data ? options.data : ""}
                name="select-list"
                validators={["required"]}
                errorMessages={"Không được để trống"}
                InputProps={{
                  className: classes.input,
                }}>
                {content.map((item) => {
                  return (
                    <MenuItem key={item + index} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextValidator
                id="outlined-full-width"
                margin="normal"
                label={`Ghi chú câu hỏi ${index + 1}`}
                variant="outlined"
                disabled={disabled}
                className={classes.input}
                onChange={(event) => this.handleChangeComment(event, id)}
                value={note}
                name="note"
                multiline
                rows={3}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>
        );
      }
      case "file": {
        return (
          options &&
          options.length > 0 &&
          options.map((item) => {
            return (
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  {!disabled && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}>
                      <Typography style={{ marginRight: 5 }}>
                        Upload file
                      </Typography>
                      <CloudUpload />
                      <input
                        type="file"
                        name="fileName"
                        id="fileName"
                        style={{ marginLeft: 15 }}
                        onChange={(e) => this.upload(e, type, id, item.id)}
                      />
                    </div>
                  )}
                  {item.text ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}>
                      <Typography style={{ marginRight: 5 }}>
                        Download file
                      </Typography>
                      <CloudDownloadIcon />
                      <button
                        type="button"
                        style={{ marginLeft: 15 }}
                        onClick={() => this.download(item.text)}>
                        Download
                      </button>
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label={`Ghi chú câu hỏi ${index + 1}`}
                    variant="outlined"
                    disabled={disabled}
                    className={classes.input}
                    onChange={(event) => this.handleChangeComment(event, id)}
                    value={note}
                    name="note"
                    multiline
                    rows={3}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })
        );
      }
      case "multi-check-box": {
        return (
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormGroup>
                {options && options.length > 0
                  ? options.map((item, key) => {
                      return (
                        <FormControlLabel
                          key={key}
                          checked={
                            (question.checked &&
                              question.checked.length > 0 &&
                              question.checked.some(
                                (valid) => valid.id === item.id
                              )) !== undefined
                              ? question.checked &&
                                question.checked.length > 0 &&
                                question.checked.some(
                                  (valid) => valid.id === item.id
                                )
                              : false
                          }
                          control={
                            <Checkbox
                              onChange={(e) => this.handleChangeCheckBox(e, id)}
                              value={item.id}
                              disabled={disabled}
                              classes={{
                                disabled: classes.disabled
                                  ? classes.disabled
                                  : "",
                              }}
                              name="multi-check-box"
                            />
                          }
                          classes={{
                            disabled: classes.label ? classes.label : "",
                          }}
                          label={item.text}
                        />
                      );
                    })
                  : null}
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextValidator
                id="outlined-full-width"
                margin="normal"
                label={`Ghi chú câu hỏi ${index + 1}`}
                variant="outlined"
                disabled={disabled}
                className={classes.input}
                onChange={(event) => this.handleChangeComment(event, id)}
                value={note}
                name="note"
                multiline
                rows={3}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>
        );
      }
      case "select": {
        return (
          <Grid container spacing={24}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={layout ? layout : 6}
              xl={layout ? layout : 6}>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Nội dung"
                disabled={disabled}
                variant="outlined"
                className={classes.input}
                onChange={(e) =>
                  this.handleChangeContentViaRefference(e, id, options.id)
                }
                value={
                  question.selected_id && question.selected_id
                    ? question.selected_id
                    : ""
                }
                name="select"
                InputProps={{
                  className: classes.input,
                }}>
                {options.map((item, index) => {
                  return (
                    <MenuItem key={item.text + index} value={item.id}>
                      {item.text}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextValidator
                id="outlined-full-width"
                margin="normal"
                label={`Ghi chú câu hỏi ${index + 1}`}
                variant="outlined"
                disabled={disabled}
                className={classes.input}
                onChange={(event) => this.handleChangeComment(event, id)}
                value={note}
                name="note"
                multiline
                rows={3}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>
        );
      }
      case "scale": {
        const start = options && options[0].text[0].value;
        const end = options && options[0].text[1].value;
        const textStart = options && options[0].text[0].text;
        const textEnd = options && options[0].text[1].text;

        const radio = [];

        for (let i = start; i <= end; i++) {
          radio.push(i);
        }

        return (
          <Grid container spacing={24}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ display: "flex" }}>
              <Typography
                component="p"
                style={{ fontWeight: "bold", paddingTop: "14px" }}>
                {textStart}
              </Typography>
              {radio.length > 0 &&
                radio.map((item) => {
                  return (
                    <Radio
                      checked={
                        question.selected ? question.selected === item + "" : ""
                      }
                      onChange={(e) =>
                        this.handleChangeContentViaRefference(e, id, options.id)
                      }
                      value={item + ""}
                      disabled={disabled}
                      classes={{
                        disabled: classes.disabled ? classes.disabled : "",
                      }}
                      name="radio-button-demo"
                    />
                  );
                })}
              <Typography
                component="p"
                style={{ fontWeight: "bold", paddingTop: "14px" }}>
                {textEnd}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextValidator
                id="outlined-full-width"
                margin="normal"
                label={`Ghi chú câu hỏi ${index + 1}`}
                variant="outlined"
                disabled={disabled}
                className={classes.input}
                onChange={(event) => this.handleChangeComment(event, id)}
                value={note}
                name="note"
                multiline
                rows={3}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>
        );
      }
      default:
        break;
    }
  };

  render() {
    const {
      // id,
      // type,
      title,
      // note,
      // options,
      classes,
      // reasonSelectList,
      index,
    } = this.props;

    return (
      <React.Fragment>
        <h3 style={{ fontWeight: "bold" }}>{index + 1 + ". " + title}</h3>
        <TextField
          style={{ display: "none" }}
          id="outlined-full-width"
          margin="normal"
          className={classes.input}
          value={index + 1 + ". " + title}
          disabled
          helperText={""}
          InputProps={{
            className: classes.input,
          }}
        />
        <Divider />
        {this.renderTypeForm()}
      </React.Fragment>
    );
  }
}
FormCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
  onUpdateSate: PropTypes.func,
  onUpdateComment: PropTypes.func,
};

FormCampaign.defaultProps = {
  id: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  note: PropTypes.string,
  options: PropTypes.array,
  token: PropTypes.string,
  reasonSelectList: PropTypes.array,
  disabled: false,
};

export default FormCampaign;
